import React from 'react';
import SubscribeContent from 'components/admin/manage/subscribe/SubscribeContent';

export const SubscribePage: React.FC = () => {
  return <SubscribeContent />;
};
